export default __webpack_public_path__ + "static/media/add lock.263ca046.svg";